import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  ReferenceBook,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const api = createApi({
  reducerPath: 'positionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/positions`,
  }),
  tagTypes: ['Position'],
  endpoints: builder => ({
    getPositions: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['Position'],
    }),
    getPositionsI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['Position'],
    }),
  }),
});

export const positionsApi = api;

export const { useGetPositionsQuery } = api;

export const useGetPositionsInfiniteQuery = normalizeInfiniteQueryData(
  api.useGetPositionsIInfiniteQuery,
);
